import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PushNotification } from './shared/components/push-notification/push-notification';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, PushNotification],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('sacich-clientes');
}
